import getPageviewData from "./data-supplier";

export class LayoutContent extends HTMLElement {
    static tag = "layout-content";
    static {
        if (!customElements.get(LayoutContent.tag)) {
            customElements.define(LayoutContent.tag, LayoutContent);
        }
    }
  
  connectedCallback() {
    this.data = getPageviewData();
    const dlPageview = this.generateDlPageview(this.data);
    this.appendChild(dlPageview);
  }

  generateDlPageview(data) {
    const dlPageview = document.createElement("DL-PAGEVIEW");
    for (const [key, value] of Object.entries(data)) {
      if (typeof value === 'object') {
        dlPageview.setAttribute(key, JSON.stringify(value));
      } else {
        dlPageview.setAttribute(key, value);
      }
    }
    return dlPageview;
  }
}